import React from 'react';
import { I18n as I }     from 'react-redux-i18n'

class ForbiddenRouteMatch extends React.Component {
    render() {
        return (
            <div>
                <h2>Error 403</h2>
                <h4>{ I.t('NOT_AUTHORIZED_TO_VIEW_PAGE') }</h4>
            </div>
        );
    }
}

export default ForbiddenRouteMatch;